import React from "react"
import { graphql, useFragment } from "react-relay"

import { EntitlementsProvider_billing$key } from "./__generated__/EntitlementsProvider_billing.graphql"

import EntitlementsContext, {
  EntitlementFeatureType,
} from "./EntitlementsContext"
import { CHARGEBEE_PROFESSIONAL_TRIAL_PRICE_ITEM_ID } from "./plansAndFeatures"

type Props = {
  billing: EntitlementsProvider_billing$key
  children: React.ReactNode
}

const FRAGMENT = graphql`
  fragment EntitlementsProvider_billing on Billing {
    subscription {
      id
      isInTrial
      plan {
        itemPriceId
      }
    }
    entitlements {
      featureId
      featureType
      value
    }
  }
`

const EntitlementsProvider = (props: Props) => {
  const { children, billing } = props
  const data = useFragment(FRAGMENT, billing)

  return (
    <EntitlementsContext.Provider
      value={{
        entitlements: data?.entitlements
          ? data.entitlements.map((e) => ({
              ...e,
              featureType: e.featureType as EntitlementFeatureType,
            }))
          : null,
        isInTrial: data?.subscription?.isInTrial ?? false,
        plan:
          data?.subscription?.plan?.itemPriceId ??
          // This won't be correct in a situation where someone has an account with
          // no subscription but we need something. Given an account with no
          // subscription cannot access the billing page, this is an acceptable
          // fallback and the account should never see this value used anywhere.
          CHARGEBEE_PROFESSIONAL_TRIAL_PRICE_ITEM_ID,
      }}
    >
      {children}
    </EntitlementsContext.Provider>
  )
}

export default EntitlementsProvider
